import axios from 'axios'
import AccountUser from "./AccountUser";

class Account {
  static $user = AccountUser;

  constructor() {

  }


  static init() {
    return new Promise((resolve, reject) => {
      Account
        .user
        .current()
        .then(data => {
          resolve();
          console.log(data.auth);
        })
        .catch(reject);
    })
  }

  static get user() {
    return this.$user;
  }

  static get auth() {
    return this.$user.auth;
  }
}

export default Account;